module.exports = __webpack_public_path__ + "static/media/background_heart.625dcbe4.svg";